import {Typography  } from '@mui/material';
import "./SubscriptionTitle.css";
import { useTranslation, Trans } from "react-i18next"; 



export default function SubscriptionTitle(){
    const { t } = useTranslation();

    return(
        <div>
            <Typography
                variant="h2"
                sx={{
                    color: '#3F4C52',
                    textAlign: 'center',
                    fontFamily: 'DM Serif Display',
                     fontSize: {
                                    xs: '6vw', // Font size for extra small screens
                                    sm: '6vw', // Font size for small screens
                                    md: '6vw', // Font size for medium screens
                                    lg: '3.5vw', // Font size for large screens
                                    xl: '2.5vw' // Font size for extra large screens
                                },
                    fontStyle: 'normal',
                    fontWeight: 400,
                }}
            >
                                {t("loadingTitle")}

            </Typography><br></br>
            <Typography
                variant="h4"
                sx={{
                    color: 'var(--taupe-fonc, #2E2E2E)',
                    textAlign: 'center',
                    fontFamily: 'Lato',
                    fontSize: '18px',
                    fontStyle: 'normal',
                    fontWeight: 400,
                     lineHeight:'30px'
                }}
            >    <Trans
          i18nKey="loadingSubtitle"
          components={{ 1: <br /> }}

                                />

            </Typography>
        </div>
    );
}